module.exports = __webpack_public_path__ + "media/besofen_3.5f38bcfb.mp4";